import { render, staticRenderFns } from "./bulk_certificates.vue?vue&type=template&id=095df110&lang=true"
import script from "./bulk_certificates.vue?vue&type=script&lang=js"
export * from "./bulk_certificates.vue?vue&type=script&lang=js"
import style0 from "./bulk_certificates.vue?vue&type=style&index=0&id=095df110&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports